import React from 'react'
import { useSetRecoilState } from 'recoil'
import { Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { Button } from '/src/components/common'
import { enquiryModalDisplayState } from '/src/components/enquiry/modal/enquiryModalState'
import { EnquiryModal } from '/src/components/enquiry'

import './send_enquiry.scss'

export const SendEnquiryBlock = () => {
  const setDisplay = useSetRecoilState(enquiryModalDisplayState)

  const onClickHandler = () => {
    setDisplay(() => {
      return {
        type: 'default',
        display: true
      }
    })
  }

  return (
    <>
      <div className="enquiry-block-container">
        <Row className="d-flex align-items-center">
          <Col sm={6} md={8}>
            <h4>
              Can't find what you're looking for? Contact our customer service on 
              <a href="tel:1300306204" className="phone">1300 306 204</a> 
              or
            </h4>
          </Col>
          <Col sm={6} md={4} className="d-flex justify-content-end">
            <Button variant="outline" onClick={onClickHandler}>
              Send Enquiry
              <FontAwesomeIcon icon={faEnvelope} />
            </Button>
          </Col>
        </Row>
      </div>
      <EnquiryModal />
    </>
  )
}
